module.exports = __webpack_public_path__ + "img/file2.8bb2f097.png";